

import './App.css';
import "./styles/Header.css"
import About from './components/About';
import Footer from './components/Footer';
import Button from '@mui/material/Button';
import { Icon } from "@mui/material";
import fatihdurmaz from "./resources/fatihdurmaz.pdf"
import Hello from "./components/Hello.js"
import Xp from "./components/Xp.js"
import { useRef } from 'react';
import Header from './components/Header';
function App() {

  const aboutRef = useRef(null);
  const helloRef= useRef(null);
  const xpRef= useRef(null);

  const handleAbout = ()=>{
    aboutRef.current.scrollIntoView({ behavior: 'smooth' })
  }
  const handleXp = () =>{
    xpRef.current.scrollIntoView({ behavior: 'smooth' })
  }
  return (
    <div className="App">
      <div className="container">
      <Header scrollXp={handleXp} scrollAbout={handleAbout} />
      <Hello refProp={helloRef}/>
      <About refProp={aboutRef}/>
      <Xp refProp={xpRef}/>
      <Footer id="footer"/>
      </div>
    </div>
  );
}

export default App;
